(ns iris.posts.subs
  (:require
   [re-frame.core :as re-frame]
   [iris.posts.common :refer [DESIRED-POST-FILTER-ORDER]]
   [iris.subs :as subs]
   [clojure.string :as string]))



(re-frame/reg-sub
 ::data
 (fn [db]
   (get-in db [:posts :data])))

(re-frame/reg-sub
 ::route-loading?
 (fn [db]
   (true? (get-in db [:posts :route-loading?]))))

(re-frame/reg-sub
 ::route-load
 (fn [db]
   (get-in db [:posts :route-load])))

(re-frame/reg-sub
 ::fb-data
 (fn [db [_ k id]]
;;  (fn [db]
   (get-in db [:posts :fb-data k id])))

(re-frame/reg-sub
 ::timer
 (fn [db]
   (get-in db [:posts :timer])))

(re-frame/reg-sub
 ::font-size
 (fn [db]
   (get-in db [:posts :font-size])))


;; (re-frame/reg-sub
;;  ::ws
;;  (fn [db]
;;    (get-in db [:posts :ws])))

;; (re-frame/reg-sub
;;  ::ws-sync
;;  (fn [db]
;;    (get-in db [:posts :ws-sync])))


;; ;; TODO: because this is supposed to get WS from header ruid (/acme.TLO),
;; ;;       same thing should be done with hashtags (/h/somehash.TLO)
;; ;; 12/23/22 added for hashtags
;; (re-frame/reg-sub
;;  ::ws-or
;;  (fn [query-v]
;;    [(re-frame/subscribe [::subs/route-params])
;;     (re-frame/subscribe [::ws])])
;;  (fn [[rp ws] query-v]
;;   ;;  (if (and (:header rp) (re-find #"^.+\.[A-Z]{3}$" (:header rp)))
;;   ;;    (subs (:header rp) (+ 1 (string/last-index-of (:header rp) ".")))
;;   ;;    ws)
;;    (cond (and (:header rp) (re-find #"^.+\.[A-Z]{3}$" (:header rp)))
;;          (subs (:header rp) (+ 1 (string/last-index-of (:header rp) ".")))
;;          (and (:tag rp) (re-find #"^.+\.[A-Z]{3}$" (:tag rp)))
;;          (subs (:tag rp) (+ 1 (string/last-index-of (:tag rp) ".")))
;;          :else
;;          ws)))


(re-frame/reg-sub
 ::limit
 (fn [db]
   (get-in db [:posts :limit])))

(re-frame/reg-sub
 ::meta
 (fn [db]
   (get-in db [:posts :meta])))


(re-frame/reg-sub
 ::batch-meta
 (fn [db]
   (get-in db [:posts :batch-meta])))


;; (re-frame/reg-sub
;;  ::batch-meta-screning-status
;;  (fn [db [_ k]]
;;    (get-in db [:posts :batch-meta :screening_status (keyword k)])))

(re-frame/reg-sub
 ::screning-status
 (fn [db [_ k]]
   (get-in db [:posts :screening-status (keyword k)])))


;; (re-frame/reg-sub
;;  ::query-params
;;  (fn [query-v]
;;    [(re-frame/subscribe [::subs/query-params])
;;     (re-frame/subscribe [::ws-or])
;;     (re-frame/subscribe [::limit])])
;;  (fn [[qp ws-or limit] query-v]
;;    (println "::ws-or" ws-or)
;;    ;; (merge {:ws ws :limit limit} qp)
;;    (merge {:ws ws-or :limit limit} qp)
;;    ))

(re-frame/reg-sub
 ::query-params
 (fn [query-v]
   [(re-frame/subscribe [::subs/query-params])
    (re-frame/subscribe [::subs/ws-or])
    (re-frame/subscribe [::limit])])
 (fn [[qp ws-or limit] query-v]
   ;; (merge {:ws ws :limit limit} qp)
   (merge {:ws ws-or :limit limit} qp)))


(re-frame/reg-sub
 ::header
 (fn [db]
   (get-in db [:posts :header])))


(re-frame/reg-sub
 ::message
 (fn [db]
   (get-in db [:posts :message])))

;; (re-frame/reg-sub
;;  ::filter-data
;;  (fn [db]
;;    (get-in db [:posts :filter-data])))

(re-frame/reg-sub
 ::filter-data
 (fn [db]
   (let [filters (get-in db [:posts :filter-data])
         order-map (zipmap DESIRED-POST-FILTER-ORDER (range))]
     ;; Note: max integer is there to sort unkown params/keys to the end of the list instead of crashing sort
     (sort-by #(get order-map (:param %) js/Number.MAX_SAFE_INTEGER) filters))))



(re-frame/reg-sub
 ::eid-metadata
 (fn [db [_ eid]]
   (get-in db [:posts :eid :metadata eid])))

(re-frame/reg-sub
 ::eid-logs
 (fn [db]
   (get-in db [:posts :eid :logs])))

(re-frame/reg-sub
 ::eid-screening
 (fn [db]
   (get-in db [:posts :eid :screening])))

(re-frame/reg-sub
 ::all-moderation-log
 (fn [db [_ id]]
   (get-in db [:posts :all-moderation-log-data (keyword id)])))

(re-frame/reg-sub
 ::moderation-logs
 (fn [db [_ id]]
   (get-in db [:posts :moderation-log-data])))

(re-frame/reg-sub
 ::batch-datetime
 (fn [db]
   (get-in db [:posts :batch-datetime])))

(re-frame/reg-sub
 ::posts-ref-preview-data
 (fn [db [_ paruid]]
   (get-in db [:posts :ref-preview-data (keyword paruid)])))
